import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ModalIconCustomComponent } from 'src/app/theme/components/modal-icon-custom/modal-icon-custom.component';

@Injectable({
  providedIn: 'root',
})
export class DialogServiceCustom{

  constructor(private dialog: MatDialog) { }
  dialogRef: MatDialogRef<ModalIconCustomComponent>;
  
  public open(options) {
    if(options){
      this.dialogRef = this.dialog.open(ModalIconCustomComponent, {   
        height: 'auto',
        width: '668px',
        panelClass: 'custom-dialog-container',
        //panelClass: 'custom-sm-dialog-container',
        data: {
          icon: options.icon,//'info',
          title: options.title,
          content: options.content,
          bullet: options.bullet,
          bold: options.bold,
          confirmbtn: options.confirmbtn,
          cancelbtn: options.cancelbtn        
      }});
    }
    
  }
  
  public confirmed(): Observable<any> {
    
    return this.dialogRef.afterClosed().pipe(take(1), map(res => {
        return res;
      }
    ));
  }

}
